import { render, staticRenderFns } from "./pickingOrder.vue?vue&type=template&id=06c5b0ce"
import script from "./pickingOrder.vue?vue&type=script&lang=js"
export * from "./pickingOrder.vue?vue&type=script&lang=js"
import style0 from "./pickingOrder.vue?vue&type=style&index=0&id=06c5b0ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports